import {FC} from "react";
import "./bento-loading-screen.scss";

interface BentoLoadingScreenProps {
    /** Optional status text shown beneath the spinner (e.g. "Authenticating..."). */
    text?: string;
    /**
     * "fullscreen" (default) covers the viewport — used for initial auth/load.
     * "contained" fills its positioned parent — used inside the persistent shell
     * so the sidebar and header stay visible while page content loads.
     */
    variant?: "fullscreen" | "contained";
}

const insightsLogo = "/Lightbulb.png";

// Loader styled to match the dark PAR Intelligence (Bento) shell, so navigating
// between Bento pages no longer flashes the white Semantic loader.
const BentoLoadingScreen: FC<BentoLoadingScreenProps> = ({
    text,
    variant = "fullscreen"
}) => (
    <div
        className={`bento-loading-screen${
            variant === "contained" ? " bento-loading-screen--contained" : ""
        }`}
        role="status"
        aria-live="polite"
    >
        <div className="bento-loading-screen__content">
            <div className="bento-loading-screen__badge">
                <span className="bento-loading-screen__spinner" aria-hidden="true" />
                <img
                    src={insightsLogo}
                    alt=""
                    className="bento-loading-screen__logo"
                />
            </div>
            {text && <p className="bento-loading-screen__text">{text}</p>}
        </div>
    </div>
);

export default BentoLoadingScreen;
